var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',_vm._l((_vm.children),function(node){return _c('option',{key:node.id,domProps:{"value":node.id}},[_vm._v(" "+_vm._s(node.layout.caption)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }